import {
  Avatar,
  AvatarGroup,
  Box,
  Button,
  Center,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  HStack,
  Img,
  Input,
  Link,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Switch,
  Text,
  useBreakpointValue,
  useColorModeValue as mode,
  useColorModeValue,
  useDisclosure,
  useMediaQuery,
} from "@chakra-ui/react";
import { fontFamily } from "html2canvas/dist/types/css/property-descriptors/font-family";
import { useSession } from "next-auth/react";
import { useRouter } from "next/dist/client/router";
import Image from "next/image";
import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import ShoutoutEmbed from "shoutout-react";
import { useLocation } from "utils/useLocation";
import { guessTimezone, updateEmail } from "../../controllers/settings";
import { setInLocalStorage } from "../../utils/helpers";
import { useFirebaseUser } from "../../utils/useFirebaseUser";
import { BillingFrequency, DurationSwitcher } from "../duration-switcher";
import { GiftGuide } from "../gift-guide";
import { Plans } from "../pricing/plans";
import { discounts } from "../pricing/pricing";
import { SocialProof } from "../social-proof";
import p1 from "./1.webp";
import p2 from "./2.webp";
import p3 from "./3.webp";
import p4 from "./4.webp";
import p5 from "./5.webp";
import p6 from "./6.webp";
import p7 from "./7.webp";
import p8 from "./8.webp";
import p9 from "./9.webp";
import p10 from "./10.webp";
import p11 from "./11.webp";
import p12 from "./12.webp";
import p13 from "./13.webp";
import p14 from "./14.webp";
import { textStyles } from "theme/textStyles/textStyles";
import { textStyle } from "theme/names";

function GetMoreOutOfLinkedIn() {
  const color = useColorModeValue("taplio.500", "taplioAccent.300");

  return (
    <Center>
      <Flex {...{ flexDirection: "column", textAlign: "center" }}>
        <Heading
          mt="4"
          textAlign="center"
          fontWeight="800" // fontSize="46px"
          maxW="500px"
          {...{
            fontFamily: "inter",
            color,
            fontSize: "2xl",
          }}
        >
          <b>Find the plan that fits your needs</b>
        </Heading>
        <Text
          {...{
            fontFamily: "inter",
            color,
            fontSize: "md",
            mt: 2,
          }}
        >
          Less time. More results.
        </Text>
      </Flex>
    </Center>
  );
}

function SpecialOfferButton() {
  return (
    <Center>
      <Button
        mt={"8"}
        color={"taplio.0"}
        bgGradient="linear(to-r, #3CB9C1, blue.300, rgba(213, 47, 107, 0.75))"
        _hover={{
          bgGradient:
            "linear(to-r, #3CB9C1cc, blue.200,  rgba(213, 47, 107, 0.65))",
        }}
        cursor="pointer"
        fontSize="lg"
        size="md"
        paddingX="8"
        as={"a"}
        target="_blank" // href={url}
        onClick={() => {
          //   ;
        }}
      >
        🎁 Special offer: $1 for a month with code PRODUCTHUNT
      </Button>
    </Center>
  );
}

function MonthlyYearlySwitch({
  billingFrequency,
  setBillingFrequency,
}: {
  billingFrequency: BillingFrequency;
  setBillingFrequency: Dispatch<SetStateAction<BillingFrequency>>;
}) {
  const color = useColorModeValue(undefined, "taplio.100");
  return (
    <Center mt={"6"} fontWeight={400} fontFamily="poppins" color={color}>
      <Box
        {...{
          as: "span",
          fontWeight: billingFrequency === "monthly" ? 700 : 400,
        }}
      >
        monthly
      </Box>
      <Switch
        variant={"taplio"}
        isChecked={billingFrequency === "yearly"}
        onChange={(e) => {
          setBillingFrequency(e.target.checked ? "yearly" : "monthly");
        }}
        m={2}
      />
      <Box
        {...{
          as: "span",
          fontWeight: billingFrequency === "yearly" ? 700 : 400,
          mr: 2,
        }}
      >
        yearly
      </Box>

      <b>(save 25%)</b>
    </Center>
  );
}

function AreYouAnAgency({ linkTo }: { linkTo: string }) {
  return (
    <Center mt="6" fontWeight={400} fontSize={"xs"}>
      <Text
        {...{
          fontFamily: "inter",
        }}
      >
        Are you an agency or team looking to have multiple Taplio accounts?{" "}
        <Link href={linkTo} target="_blank" mx={1} fontWeight={700}>
          <Text as="u">Read more</Text>
        </Link>{" "}
        on how to do it
        <Link href={linkTo} target="_blank" ml={1}>
          here
        </Link>
        .
      </Text>
    </Center>
  );
}

export const OnboardNewChoice = ({
  discount,
  query,
  withCounter = false,
  forceBillingFrequency = undefined as any,
}) => {
  const router = useRouter();
  const { data: session, status } = useSession() ?? {};
  const loading = status === "loading";
  const [email, setEmail] = useState("");
  const [billingFrequency, setBillingFrequency] = useState<BillingFrequency>(
    forceBillingFrequency ?? "monthly"
  );
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isLoading, setIsLoading] = useState(false);
  const initialRef = useRef<HTMLInputElement>(null);
  const isAuthenticated = useFirebaseUser();
  const { isFromIndia } = useLocation();
  const [isTooSmall] = useMediaQuery("(max-width: 800px)");

  useEffect(() => {
    // let isSkipped = (localStorage.getItem('isSkippedEmailPopup') == "true");
    // console.log("isSkipped: " + isSkipped);
    // if (!isSkipped)
    //   onOpen();
  }, []);

  useEffect(() => {
    if (!email && session?.user?.data?.email)
      //@ts-ignore
      setEmail(session?.user?.data?.email);

    if (isAuthenticated) guessTimezone(session);
  }, [session, isAuthenticated]);

  useEffect(() => {
    if (isFromIndia) {
      setBillingFrequency("yearly");
    }
  }, [isFromIndia]);

  const skipPopup = () => {
    onClose();
    setInLocalStorage("isSkippedEmailPopup", "true");
  };

  const imageDimension = useBreakpointValue([30, 40, 50]);
  const imageLeftMargin = useBreakpointValue([-2, -2, -4]);
  const imageBorderSize = useBreakpointValue([2, 2, 4]);

  const banner = query.ref === "producthunt" && (
    <Box
      as="section"
      px={{ base: "6", md: "8" }}
      marginTop={{ base: "-4", lg: "-8" }}
    >
      <HStack
        justifyContent="center"
        border="4px"
        maxWidth="lg"
        margin="auto"
        borderRadius="xl"
        borderColor="#da5630"
        padding="2"
        textAlign="center"
      >
        <Text fontWeight="medium">
          <b>Product Hunters</b> 👉 grab a plan and get your first month for $1
          🎉
        </Text>
      </HStack>
    </Box>
  );

  // console.log('discount onboardNewChoice:', discount)

  return (
    <>
      <GetMoreOutOfLinkedIn />
      {/* <SpecialOfferButton /> */}
      {/* <AreYouAnAgency {...{ linkTo: "" }}></AreYouAnAgency> */}

      <Center
        {...{ textStyle: textStyle["h4.medium.standard"], mt: [8, 8] }}
        textAlign="center"
      >
        Trusted by 6,200+ experts, founders, marketers and professionals
      </Center>
      <Flex
        {...{
          flexWrap: "wrap",
          justifyContent: "center",
          mt: [2, 4],
          mb: [0, 2],
        }}
      >
        {[p1, p2, p3, p4, p5, p6, p7, p8, p9, p10, p11, p12, p13, p14].map(
          (pic, i) => (
            <Box
              key={i}
              borderRadius="full"
              overflow={"hidden"}
              border={`${imageBorderSize}px solid white`}
              w={imageDimension}
              h={imageDimension}
              ml={imageLeftMargin}
            >
              <Image
                key={i}
                {...{
                  src: pic,
                  alt: "taplio user",
                  borderradius: "full",
                  objectFit: "cover",
                }}
              ></Image>
            </Box>
          )
        )}
      </Flex>

      <MonthlyYearlySwitch {...{ billingFrequency, setBillingFrequency }} />

      <Plans
        billingFrequency={billingFrequency}
        discount={discount}
        customCancelUrl="onboardnewchoice"
        isFromIndia={isFromIndia}
        withCounter={withCounter}
      />
    </>
  );

  // return (
  //   <>
  //     {/* {banner} */}
  //     <Box as="section" py="10">
  //       <Box
  //         maxW={{ base: "xl", md: "7xl" }}
  //         mx="auto"
  //         px={{ base: "6", md: "8" }}
  //       >
  //         <Center>
  //           <Heading
  //             mt="4"
  //             textAlign="center"
  //             fontWeight="900"
  //             // fontSize="46px"
  //             maxW="500px"
  //             {...{
  //               fontFamily: "inter",
  //               color: "taplio.600",
  //               fontSize: "xl",
  //             }}
  //           >
  //             <b>Start getting results from LinkedIn</b>
  //           </Heading>
  //         </Center>
  //         {/* </Center>
  //         <Center>
  //           <Heading
  //             mt="4"
  //             textAlign="center"
  //             fontWeight="900"
  //             fontSize="46px"
  //             maxW="500px"
  //           >
  //             <b>Ready To Increase Your Follower Count?</b>
  //           </Heading>
  //         </Center> */}

  //         <SocialProof />
  //         {/* {
  //           !isTooSmall && (
  //             <SocialProof />
  //           )
  //         } */}

  //         {isFromIndia && (!discount || discount == discounts.india.yearly) && (
  //           <DurationSwitcher
  //             mt={{ base: "4", lg: "-6" }}
  //             mb="10"
  //             onChange={() =>
  //               setBillingFrequency(
  //                 billingFrequency === "monthly" ? "yearly" : "monthly"
  //               )
  //             }
  //             billingFrequency={billingFrequency}
  //             discountOf="40"
  //           />
  //         )}

  //         {(discount == "EARLYBIRD" || discount == "EARLYACCESS") && (
  //           <Center>
  //             <GiftGuide
  //               title="🎁 EARLY ACCESS SPECIAL 🎁"
  //               description="Get powerful AI features for the price of the starter plan"
  //               bg={mode("blue.400", "gray.700")}
  //               maxW={"600px"}
  //               rounded="full"
  //               p={4}
  //               style={{
  //                 title: { w: "250px", top: "-35px" },
  //                 description: { color: "white" },
  //               }}
  //             />
  //           </Center>
  //         )}

  //         <Plans
  //           billingFrequency={billingFrequency}
  //           discount={discount}
  //           customCancelUrl="onboardnewchoice"
  //           isFromIndia={isFromIndia}
  //         />

  //         {
  //           // session?.user?.data?.abTestFreeGuide && (
  //           // <Center>
  //           //   <GiftGuide title="Included 🎁" description="Our 25+ pages Twitter Growth Guide 📕 (valued $49)" bg={mode("gray.700", "gray.700")} />
  //           // </Center>
  //           // )
  //         }
  //       </Box>
  //     </Box>

  //     <Box p={4} display="flex" flexDirection="column" alignItems="center">
  //       <Heading textAlign="center" mt={8} mb={16}>
  //         See what people say about us
  //       </Heading>
  //       <Box minWidth="60%" maxWidth="1200px">
  //         {/* <div className="shoutout-embed" data-wall="TweetHunter"></div> */}
  //         <ShoutoutEmbed url="influentleaders" />
  //       </Box>
  //       <Modal
  //         isOpen={isOpen}
  //         onClose={skipPopup}
  //         closeOnOverlayClick={false}
  //         //@ts-ignore
  //         initialFocusRef={initialRef}
  //         size="xl"
  //       >
  //         <ModalOverlay bg="white" />
  //         <ModalContent>
  //           <ModalHeader>
  //             <Box display="flex" justifyContent="space-between">
  //               <Text>
  //                 {"Thanks for signing up " +
  //                   (session?.user?.data?.name
  //                     ? session?.user?.data?.name
  //                     : "")}
  //               </Text>
  //               {session?.user?.image && (
  //                 <Img
  //                   w="10"
  //                   h="10"
  //                   rounded="3xl"
  //                   objectFit="cover"
  //                   src={session?.user?.image}
  //                   alt="Chakra UI"
  //                   mr={2}
  //                 />
  //               )}
  //             </Box>
  //           </ModalHeader>
  //           <ModalBody pb={6}>
  //             <FormControl
  //               as="form"
  //               onSubmit={(e) => {
  //                 e.preventDefault();
  //               }}
  //             >
  //               <FormLabel pb={3} pl={1} fontSize="md" fontWeight="400">
  //                 You’re a couple steps away from unlocking the power of Tweet
  //                 Hunter and <b>becoming a tweet machine.</b>
  //               </FormLabel>
  //               <FormLabel pb={3} pl={1} fontSize="md" fontWeight="400">
  //                 We use email to send you{" "}
  //                 <b>personalized tweet recommendations</b> and perform an{" "}
  //                 <b>AI-powered analysis of your Twitter account.</b>
  //               </FormLabel>
  //               <FormLabel pb={5} pl={1} fontSize="md" fontWeight="400">
  //                 <b>
  //                   Could you please confirm this email is the one you usually
  //                   check?
  //                 </b>{" "}
  //                 Or change it to your usual email.
  //               </FormLabel>
  //               <Input
  //                 type="email"
  //                 ref={initialRef}
  //                 placeholder="Your email address"
  //                 value={email}
  //                 onChange={(e) => setEmail(e.target.value)}
  //               />
  //             </FormControl>
  //           </ModalBody>

  //           <ModalFooter mb={2}>
  //             <Button
  //               onClick={async () => {
  //                 setIsLoading(true);
  //                 updateEmail(session?.user?.uid, email);
  //                 skipPopup();
  //                 setIsLoading(false);
  //               }}
  //               colorScheme="blue"
  //               isLoading={isLoading}
  //             >
  //               Save
  //             </Button>
  //           </ModalFooter>
  //         </ModalContent>
  //       </Modal>
  //     </Box>
  //   </>
  // );
};
